import { Group } from '@studio/design-system/form';
import { Mediator } from '@studio/design-system/input';
import * as Switch from '@studio/design-system/switch';
import { clamp } from '@studio/js-utils/range';
import { OffsetRange } from '@studio/models/audio';
import { useLatestFn } from '@studio/react-utils/hooks';
import { isNotNil, toNumber } from '@tryiris-ai/js-types';
import { useState } from 'react';
import type { ReactElement, SyntheticEvent } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';

/** `<Offset>` control. */
export const Offset = ({ offset }: Props): ReactElement => {
  const [isToggled, setToggled] = useState(!!offset.value);

  const handleCommit = useLatestFn((nextValue: string, event: SyntheticEvent) => {
    const nextOffset = toNumber(nextValue);

    if (isNotNil(nextOffset) && nextOffset !== offset.value) {
      offset.setValue(clamp(nextOffset, OffsetRange));
    } else {
      event.preventDefault();
    }
  });

  return (
    <>
      <Group label='Audio offset'>
        <Switch.Container label='Enable to adjust latency'>
          <Switch.Archetype checked={isToggled} onCheckedChange={setToggled} />
        </Switch.Container>
      </Group>

      <Group
        className={twMerge(!isToggled && '[&>label]:opacity-disabled')}
        label='Audio latency (milliseconds)'
      >
        <Mediator
          disabled={!isToggled}
          onCommit={handleCommit}
          placeholder='Offset in milliseconds'
          value={isToggled ? offset.value.toString() : ''}
        />
      </Group>
    </>
  );
};
